<template>
  <div class="jgrw-tab">
    <SlideSearch
      :categoryList="searchCategory"
      :filterList="searchFilter"
      @search="subminSearch"
      @offsearch="offSearch"
      :gisurl="gisurl"
    ></SlideSearch>
    <div class="divider"></div>

    <m-textArea class="data-list" ref="dataList">
      <div
        v-for="(item, index) in datalist"
        :key="index"
        class="data-item"
        @click="showContent(item)"
      >
        <dl>
          <dt>{{item.name}}</dt>
          <dd>专业: {{item.speciality}}</dd>
          <dd>地域: {{item.region}}</dd>
          <dd>简介: {{item.description | desc}}</dd>
        </dl>
        <div class="data-more"><span>更多 MORE</span></div>
        <div class="divider"></div>
      </div>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>

    <TextContent
      :content="content"
      :headers="headers"
      v-if="contentPage"
      @close="contentPage = false"
    ></TextContent>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import SlideSearch from "./SlideSearch";
import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";
import TextContent from "./TextContent";

export default {
  components: {
    SlideSearch,
    "m-textArea": TextArea,
    Pagination,
    TextContent
  },
  computed: {
    ...mapState(["organization"]),
    datalist() {
      if (this.onSearch) {
        return this.organization.searchres.content;
      }
      return this.organization[this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this.organization.searchres.number
        : this.organization.number;
    },
    pages() {
      return this.onSearch
        ? this.organization.searchres.total_pages
        : this.organization.total_pages;
    }
  },
  data() {
    return {
      pageName: "organization",
      headers: [
        { tag: "speciality", name: "专业" },
        { tag: "region", name: "地域" },
        { tag: "dynasty", name: "朝代" },
        { tag: "birth_year", name: "生年" },
        { tag: "death_year", name: "卒年" },
        { tag: "description", name: "简介" }
      ],
      onSearch: false,
      searchCategory: ["表演", "雕刻", "研究", "博物馆"],
      searchFilter: [
        { name: "name", title: "姓名 / 名称" },
        { name: "region", title: "地域" },
        { name: "dynasty", title: "朝代" },
        { name: "description", title: "简介" }
      ],
      searchParam: {},
      contentPage: false,
      content: {},
      gisurl: "http://amap.zju.edu.cn/maps/3217/mobile"
    };
  },
  filters: {
    desc(value) {
      return value.slice(0, 48) + "...";
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      this.searchData({
        data_name: this.pageName,
        page_num: num,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      const { category, ...param } = data;

      if (category) {
        param.speciality = category;
      }

      this.search(param);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.$refs.dataList.scroll();
    },
    showContent(data) {
      this.content = data;
      this.contentPage = true;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.jgrw-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem 0;
  overflow: hidden;

  .divider {
    height: 1px;
    padding-top: 1rem;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
  }

  & > .divider {
    margin: 0 1rem;
  }

  .data-list {
    flex: 1;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 0.875rem;

    .text-main {
      padding-right: 1rem;
    }

    .data-item {
      position: relative;
    }

    dt {
      font-size: 1rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }

    dd {
      text-align: justify;
    }

    .data-more {
      text-align: right;

      span {
        display: inline-block;
        padding-left: 1.5rem;
        padding-right: 0.25rem;
        font-size: 0.75rem;
        color: $text-dark;
        background-color: $primary;
      }
    }

    .divider {
      margin-bottom: 1rem;
    }
  }
}
</style>
